import { logProgramChange } from '@shoflo/studio-redux/utils';

import setProgram from './setProgram';
import setProgramRealtime from './setProgramRealtime';
import { getProgramLayers } from 'utils/broadcastSourceHelper';

/**
 * Builds a new scene replacing previous source values for a supplied source.
 *
 * This allows us to keep a scene unchanged except for a source that's changed, for example an audio source that has
 * changed from `muted: false` to `muted: true`.
 */
export default (changedSource, realtime = false) => {
  return (dispatch, getState) => {
    const { program } = getState();

    const nextScene = { ...program };
    const currentLayers = getProgramLayers(program);

    nextScene.layers = currentLayers.map(layerSource => {
      const { source } = layerSource;
      if (source?._id === changedSource._id) {
        return { ...layerSource, source: changedSource };
      }

      return layerSource;
    });

    if (realtime) {
      dispatch(setProgramRealtime(nextScene));
      logProgramChange(
        getState,
        'setSourceChangesToProgram action - local update'
      );
    } else {
      dispatch(setProgram(nextScene));
      logProgramChange(
        getState,
        'setSourceChangesToProgram action - persisted update'
      );
    }
  };
};
